import { useDispatch } from "react-redux";

import {
  PAGE_VIEWED,
  TRACK_CREATE_DEAL_ROOM_CLICKED_EVENT,
  TRACK_DEAL_ROOM_ACTIVITY_CLICKED_EVENT,
  TRACK_DEAL_ROOM_ACTIVITY_SECTION_VIEW,
  TRACK_DEAL_ROOM_ADD_MEETING_LINK_VIEW,
  TRACK_DEAL_ROOM_DETAIL_ASSET_SECTION_VIEW,
  TRACK_DEAL_ROOM_ASSETS_CLICKED_EVENT,
  TRACK_DEAL_ROOM_CREATE_VIEW,
  TRACK_DEAL_ROOM_CREATED_EVENT,
  TRACK_DEAL_ROOM_DELETED_EVENT,
  TRACK_DEAL_ROOM_DETAIL_VIEW,
  TRACK_DEAL_ROOM_EDIT_CLICKED_EVENT,
  TRACK_DEAL_ROOM_EDITED_EVENT,
  TRACK_DEAL_ROOM_ENGAGE_CLICKED_EVENT,
  TRACK_DEAL_ROOM_ENGAGE_SECTION_VIEW,
  TRACK_DEAL_ROOM_LIST_VIEW,
  TRACK_DEAL_ROOM_MEETING_LINK_ADDED_EVENT,
  TRACK_DEAL_ROOM_MEETING_LINK_CLICKED_EVENT,
  TRACK_DEAL_ROOM_OVERVIEW_ADDED_EVENT,
  TRACK_DEAL_ROOM_OVERVIEW_CLICKED_EVENT,
  TRACK_DEAL_ROOM_PEOPLE_SECTION_VIEW,
  TRACK_DEAL_ROOM_RENAMED_EVENT,
  TRACK_DEAL_ROOM_SEARCHED_EVENT,
  TRACK_DEAL_ROOM_SHARED_EVENT,
  TRACK_DEAL_ROOM_SHORTCUTS_CLICKED_EVENT,
  TRACK_DEAL_ROOM_SORTED_EVENT,
  TRACK_DEAL_ROOM_USERS_ADDED_EVENT,
  TRACK_DEAL_ROOM_USERS_CLICKED_EVENT,
  TRACK_CLONE_DEAL_ROOM_CLICKED_EVENT,
  TRACK_DEAL_ROOM_CLONE_CONFIRMATION_SCREEN_VIEW,
  TRACK_CLONE_DEAL_ROOM_CONFIRMATION_EVENT,
  TRACK_DEAL_ROOM_CLONED_EVENT,
  TRACK_DEAL_ROOM_TEMPLATE_CREATED,
  TRACK_DEAL_ROOM_MAP_CREATED
} from "src/constants/adoption/eventTypes";
import { trackEventForAdoption } from "../adoption";
import {
  TrackDealRoomActivitySectionViewed,
  TrackDealRoomAddMeetingLinkViewed,
  TrackDealRoomAssetSectionViewed,
  TrackDealRoomCreated,
  TrackDealRoomCreateViewed,
  TrackDealRoomDeleted,
  TrackDealRoomDetailViewed,
  TrackDealRoomEdited,
  TrackDealRoomEngageClicked,
  TrackDealRoomEngageSectionViewed,
  TrackDealRoomPeopleSectionViewed,
  TrackDealRoomRenamed,
  TrackDealRoomSearched,
  TrackDealRoomShared,
  TrackDealRoomSorted,
  TrackDealRoomUsersAdded,
  ClonedDealRoomEvent,
  TrackCreateTemplateClicked,
  TrackCreateMapCreated,
  
} from "src/types/adoption/dealRoom";

export const useDealRoomAdoption = () => {
  const dispatch = useDispatch();

  // screen view events start here
  const trackDealRoomListViewed = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_DEAL_ROOM_LIST_VIEW,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomDetailViewed = ({ source_cta }: TrackDealRoomDetailViewed) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_DEAL_ROOM_DETAIL_VIEW,
        source_cta,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomCreateViewed = ({ source_cta }: TrackDealRoomCreateViewed) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_DEAL_ROOM_CREATE_VIEW,
        source_cta,
      },
    };
    
    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomAddMeetingLinkViewed = ({ source_cta }: TrackDealRoomAddMeetingLinkViewed) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_DEAL_ROOM_ADD_MEETING_LINK_VIEW,
        source_cta,
      },
    }
    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomAssetSectionViewed = ({ source_cta }: TrackDealRoomAssetSectionViewed) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_DEAL_ROOM_DETAIL_ASSET_SECTION_VIEW,
        source_cta,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomPeopleSectionViewed = ({ source_cta }: TrackDealRoomPeopleSectionViewed) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_DEAL_ROOM_PEOPLE_SECTION_VIEW,
        source_cta,
      },
    }

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomActivitySectionViewed = ({ source_cta }: TrackDealRoomActivitySectionViewed) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_DEAL_ROOM_ACTIVITY_SECTION_VIEW,
        source_cta,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomEngageSectionViewed = ({ source_cta }: TrackDealRoomEngageSectionViewed) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_DEAL_ROOM_ENGAGE_SECTION_VIEW,
        source_cta,
      },
    };

    dispatch(trackEventForAdoption(event));
  };
  // screen view events end here

  // custom events start here
  const trackCreateDealRoomClicked = () => {
    const event = {
      event: TRACK_CREATE_DEAL_ROOM_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomCreated = ({ dealRoomName }: TrackDealRoomCreated) => {
    const event = {
      event: TRACK_DEAL_ROOM_CREATED_EVENT,
      properties: {
        dealroom_name: dealRoomName,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomSearched = ({ search_string }: TrackDealRoomSearched) => {
    const event = {
      event: TRACK_DEAL_ROOM_SEARCHED_EVENT,
      properties: {
        search_string,
      },
    }

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomRenamed = ({ renameEvent }: TrackDealRoomRenamed) => {
    const { oldName, newName } = renameEvent;
    const event = {
      event: TRACK_DEAL_ROOM_RENAMED_EVENT,
      properties: {
        old_name: oldName,
        new_name: newName,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomDeleted = ({ dealRoomName }: TrackDealRoomDeleted) => {
    const event = {
      event: TRACK_DEAL_ROOM_DELETED_EVENT,
      properties: {
        dealroom_name: dealRoomName,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomSorted = ({ sortType }: TrackDealRoomSorted) => {
    const event = {
      event: TRACK_DEAL_ROOM_SORTED_EVENT,
      properties: {
        sort_type: sortType,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomEditClicked = () => {
    const event = {
      event: TRACK_DEAL_ROOM_EDIT_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomEdited = ({ dealRoomId }: TrackDealRoomEdited) => {
    const event = {
      event: TRACK_DEAL_ROOM_EDITED_EVENT,
      properties: {
        dealroom_id: dealRoomId,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomOverviewClicked = () => {
    const event = {
      event: TRACK_DEAL_ROOM_OVERVIEW_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomOverviewAdded = () => {
    const event = {
      event: TRACK_DEAL_ROOM_OVERVIEW_ADDED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomAssetsClicked = () => {
    const event = {
      event: TRACK_DEAL_ROOM_ASSETS_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomUsersClicked = () => {
    const event = {
      event: TRACK_DEAL_ROOM_USERS_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomUsersAdded = ({ dealRoomName, userId, type }: TrackDealRoomUsersAdded) => {
    const event = {
      event: TRACK_DEAL_ROOM_USERS_ADDED_EVENT,
      properties: {
        dealRoomName,
        userId,
        type
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomMeetingLinkClicked = () => {
    const event = {
      event: TRACK_DEAL_ROOM_MEETING_LINK_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event)); 
  };

  const trackDealRoomMeetingLinkAdded = () => {
    const event = {
      event: TRACK_DEAL_ROOM_MEETING_LINK_ADDED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomEngageClicked = ({ source_cta }: TrackDealRoomEngageClicked) => {
    const event = {
      event: TRACK_DEAL_ROOM_ENGAGE_CLICKED_EVENT,
      properties: {
        source_cta,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomShortcutsClicked = () => {
    const event = {
      event: TRACK_DEAL_ROOM_SHORTCUTS_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomActivityClicked = () => {
    const event = {
      event: TRACK_DEAL_ROOM_ACTIVITY_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomShared = ({ dealRoomName }: TrackDealRoomShared) => {
    const event = {
      event: TRACK_DEAL_ROOM_SHARED_EVENT,
      properties: {
        dealroom_name: dealRoomName,
        share_medium: "Email",
      },
    };

    dispatch(trackEventForAdoption(event));
  };
  // custom events end here

  //deal room clone events
  const trackCloneDealRoomClicked = () => {
    const event = {
      event: TRACK_CLONE_DEAL_ROOM_CLICKED_EVENT,
      properties: {}
    }

    dispatch(trackEventForAdoption(event));
  };

  const trackDealRoomCloned = (cloneEvent: ClonedDealRoomEvent) => {
    const { sourceName, clonedName } = cloneEvent;
    
    const event = {
      event: TRACK_DEAL_ROOM_CLONED_EVENT,
      properties: {
        dealRoom_name: sourceName,
        cloned_dealRoom_name: clonedName
      }
    }
    
    dispatch(trackEventForAdoption(event));
  }

  const trackCloneDealRoomConfirmationScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        "screen_name": TRACK_DEAL_ROOM_CLONE_CONFIRMATION_SCREEN_VIEW
      }
    };

    dispatch(trackEventForAdoption(event));
  }

  const trackCloneDealRoomConfirmed = (dealRoomName: string) => {
    const event = {
      event: TRACK_CLONE_DEAL_ROOM_CONFIRMATION_EVENT,
      properties: {
        dealRoom_name: dealRoomName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackCreateTemplateClicked = ({ dealRoomName}: TrackCreateTemplateClicked) => {
    const event = {
      event: TRACK_DEAL_ROOM_TEMPLATE_CREATED,
      properties: {
        dealroom_name: dealRoomName
      }
    };
    dispatch(trackEventForAdoption(event));
  }

  const trackCreateMapCreated = ({ dealRoomName, stageName }: TrackCreateMapCreated) => {
    const event = {
      event: TRACK_DEAL_ROOM_MAP_CREATED,
      properties: {
        dealroom_name: dealRoomName,
        stage_name: stageName,
      }
    };
    dispatch(trackEventForAdoption(event));
  }
  return {
    trackDealRoomListViewed,
    trackDealRoomDetailViewed,
    trackDealRoomCreateViewed,
    trackDealRoomAddMeetingLinkViewed,
    trackDealRoomAssetSectionViewed,
    trackDealRoomPeopleSectionViewed,
    trackDealRoomActivitySectionViewed,
    trackDealRoomEngageSectionViewed,
    trackCreateDealRoomClicked,
    trackDealRoomCreated,
    trackDealRoomSearched,
    trackDealRoomRenamed,
    trackDealRoomDeleted,
    trackDealRoomEditClicked,
    trackDealRoomEdited,
    trackDealRoomSorted,
    trackDealRoomOverviewClicked,
    trackDealRoomOverviewAdded,
    trackDealRoomAssetsClicked,
    trackDealRoomUsersClicked,
    trackDealRoomUsersAdded,
    trackDealRoomMeetingLinkClicked,
    trackDealRoomMeetingLinkAdded,
    trackDealRoomEngageClicked,
    trackDealRoomShortcutsClicked,
    trackDealRoomActivityClicked,
    trackDealRoomShared,
    trackCloneDealRoomClicked,
    trackCloneDealRoomConfirmationScreenView,
    trackCloneDealRoomConfirmed,
    trackDealRoomCloned,
    trackCreateTemplateClicked,
    trackCreateMapCreated
  };
};
